import { Controller } from '@hotwired/stimulus';
import { lockBodyScroll, unlockBodyScroll } from '../bodyScrollLock';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['nav'];

  static values = {
    open: Boolean,
  };

  toggle(e) {
    this.openValue = !this.openValue;
    e.currentTarget.setAttribute('aria-expanded', this.openValue);

    if (this.openValue) {
      lockBodyScroll(this.navTarget);
    } else {
      unlockBodyScroll(this.navTarget);
    }
  }
}
